// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const GcpDiskType = {
  DiskTypePersistentSSD: 'pd-ssd',
  DiskTypePersistentBalanced: 'pd-balanced',
  DiskTypeHyperBalanced: 'hyperdisk-balanced',
} as const;
export type GcpDiskType = (typeof GcpDiskType)[keyof typeof GcpDiskType];

export function instanceOfGcpDiskType(value: any): boolean {
  for (const key in GcpDiskType) {
    if (Object.prototype.hasOwnProperty.call(GcpDiskType, key)) {
      if (GcpDiskType[key as keyof typeof GcpDiskType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function GcpDiskTypeFromJSON(json: any): GcpDiskType {
  return GcpDiskTypeFromJSONTyped(json, false);
}

export function GcpDiskTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpDiskType {
  return json as GcpDiskType;
}

export function GcpDiskTypeToJSON(value?: GcpDiskType | null): any {
  return value as any;
}

export function GcpDiskTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GcpDiskType {
  return value as GcpDiskType;
}
